module.exports = __webpack_public_path__ + "static/img/004txt-应用.1172955f.png";